'use client';
import React, { useRef } from 'react';

import { FaDownload, FaPrint } from 'react-icons/fa6';
import Link from 'next/link';
// import Image from 'next/image';
import InvoicePrintAria from './InvoicePrintAria';
import { HiOutlineBadgeCheck } from 'react-icons/hi';
const Invoice: React.FC = () => {
  const printRef = useRef<HTMLDivElement | null>(null);

  const handlePrint = () => {
    if (printRef.current) {
      const content = printRef.current.innerHTML;
      const originalContent = document.body.innerHTML;
      document.body.innerHTML = content; // Set only the div's content
      window.print();
      document.body.innerHTML = originalContent; // Restore original content
      window.location.reload(); // Reload to fix broken UI
    }
  };

  const notes: string[] = [
    'All amounts shown on this invoice are in US dollars.',
    'A finance charge of 20.5% will be applied to unpaid balances after 24 days.',
    'Once an order is placed, money cannot be refunded.',
    'Delivery might be delayed due to external dependencies.',
  ];

  return (
    <>
      {/* ============ Invoice Section Start Here ========== */}
      <section className="invoice padding-bottom">
        <div className="container">
          <div className="invoice__wrapper">
            <InvoicePrintAria printRef={printRef} />
            <div className="row">
              <div className="col-lg-6">
                <div className="invoice__note">
                  <h3>Important Note</h3>
                  <ul className="invoice__note-list">
                    {notes.map((note, index) => (
                      <li key={index}>
                        {/* <Image
                          width={20}
                          height={20}
                          src="/images/invoice/check.svg"
                          alt="Check"
                        /> */}
                        <div>
                          <HiOutlineBadgeCheck />
                        </div>
                        <p>{note}</p>
                      </li>
                    ))}
                  </ul>
                  <div className="btn-group no-print mt-4">
                    <Link
                      href="/images/invoice/invoice.pdf"
                      className="trk-btn trk-btn--primary"
                      download
                    >
                      <span>
                        <FaDownload />
                      </span>{' '}
                      Download
                    </Link>
                    <button
                      className="trk-btn trk-btn--gray"
                      onClick={handlePrint}
                    >
                      <span>
                        <FaPrint />
                      </span>
                      Print
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      {/* ============ Invoice Section Ends Here ========== */}
    </>
  );
};

export default Invoice;
